// src/pages/MyOrdersPage.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import OrderItem from '../components/OrderItem';

function MyOrdersPage() {
    const { user } = useAuth();
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
    if (!user?.cedula) {
        setIsLoading(false);
        return;
    }

    const fetchOrders = async () => {
        try {
            const response = await fetch(
                `https://kifli-api.onrender.com/api/users/${user.cedula}/orders`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("STATUS:", response.status);
            console.log("CONTENT-TYPE:", response.headers.get("content-type"));

            if (!response.ok) {
                throw new Error("Error HTTP: " + response.status);
            }

            const data = await response.json();
            console.log("DATA:", data);

            setOrders(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error al obtener pedidos:", error);
            setOrders([]);
        } finally {
            setIsLoading(false);
        }
    };

    fetchOrders();
}, [user?.cedula]);


    if (isLoading) {
        return <div className="text-center text-xl">Cargando tus pedidos...</div>;
    }

    if (!user) {
        return <div className="text-center text-xl">Debes iniciar sesión</div>;
    }

   return (
        <div className="max-w-6xl mx-auto px-8">
            <h1 className="text-[65px] mb-3 font-semibold">
                Hola, <span className="text-lime-300">{user.nombre || user.email}</span>
            </h1>
    
            <h2 className="text-4xl font-bold mb-8">Tus Pedidos</h2>
    
            {orders.length > 0 ? (
                <div className="overflow-x-auto pb-20">
                    <table className="min-w-full bg-zinc-900 rounded-xl overflow-hidden">
                        <thead className="bg-zinc-800 text-left">
                            <tr>
                                <th className="px-6 py-4 text-sm font-semibold">Número de Pedido</th>
                                <th className="px-6 py-4 text-sm font-semibold">Descripción</th>
                                <th className="px-6 py-4 text-sm font-semibold">Estado</th>
                            </tr>
                        </thead>
    
                        <tbody>
                            {orders.map((order) => {
                                const progress = Number(order.status);
    
                                const getLabel = (value) => {
                                    if (value < 25) return "Procesado en bodega Miami";
                                    if (value < 50) return "En transito a destino (Miami a Guayaquil)";
                                    if (value < 75) return "En proceso de aduana (Guayaquil)";
                                    if (value < 100) return "Listo para entrega al cliente";
                                    if (value === 100) return "Entregado al cliente";
                                    return "Desconocido";
                                };
    
                                return (
                                    <tr
                                        key={order.id}
                                        className="border-t border-zinc-700 hover:bg-zinc-800 transition"
                                    >
                                        <td className="px-6 py-4 font-mono">
                                            #{order.id}
                                        </td>
    
                                        <td className="px-6 py-4">
                                            {order.description}
                                        </td>
    
                                        <td className="px-6 py-4 w-64">
                                            <div className="mb-1 text-sm">
                                                {getLabel(progress)}
                                            </div>
    
                                            <div className="w-full bg-zinc-700 rounded-full h-2">
                                                <div
                                                    className="bg-lime-400 h-2 rounded-full transition-all duration-500"
                                                    style={{ width: `${progress}%` }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                <p>
                    No tienes pedidos todavía.{" "}
                    <Link to="/" className="text-lime-400 hover:underline">
                        ¡Empieza a comprar!
                    </Link>
                </p>
            )}
        </div>
    );

}

export default MyOrdersPage;
